import type { NestedMap } from './types';

// e.g. ["xs", ["top", "center", "bottom"]]
type Tuple = (string | string[])[];

const re = /([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g;
const camelCase = (str: string) =>
  (str.match(re) ?? [])
    .map((w, i) => {
      if (i === 0) return w;
      return w[0].toUpperCase() + w.slice(1);
    })
    .join('');

const makeDLSMapObj = (
  styles: { [index: string]: string },
  base: string,
  modifiers: (string | Tuple)[],
  withPrefix = true
): NestedMap =>
  modifiers.reduce(
    (
      obj: { [index: string]: string | string[] | NestedMap },
      current: string | Tuple
    ) => {
      const isArray = Array.isArray(current);
      const key = isArray ? current[0] : current;
      const clazz = camelCase(`${base} ${key}`);
      const value = isArray
        ? makeDLSMapObj(styles, clazz, current[1] as string[], false)
        : styles[clazz];

      if (value) {
        obj[`${withPrefix ? '$' : ''}${key}`] = value;
      }

      return obj;
    },
    {}
  );

export default makeDLSMapObj;
